<template>
  <div id="app">
    <router-view />
  </div>
</template>
<style>
/* @font-face {
  font-family: 'PingFangSC-Regular';
  src: url('./assets/fonts/PingFang Regular.eot');
  src: url('./assets/fonts/PingFang Regular.eot?iefix') format('embedded-opentype'),
       url('./assets/fonts/PingFang Regular.woff') format('woff'),
       url('./assets/fonts/PingFang Regular.ttf') format('truetype'),
       url('./assets/fonts/PingFang Regular.svg') format('svg');
       font-weight: normal;
       font-style: normal;
} */

body {
  overflow: hidden;
}

#app {
  /* font-family: 'PingFangSC-Regular'; */
  color: #333333;
  min-width: 1200px;
  overflow-y: scroll;
  margin-right: -17px;
  height: 100vh;
}

.ant-modal-confirm-body {
  display: flex;
  padding-top: 8px;
}

.ant-modal-confirm-body .ant-modal-confirm-content {
  margin-top: 0 !important;
}

.ant-modal-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.ant-modal {
  transform-origin: center !important;
}

.ant-modal-close {
  top: -10px !important;
  right: -10px !important;
}

.ant-modal-content {
  transform: translateY(-100px);
}

/* 表单显示错误提示时，没有对齐的兼容 */
.ant-form-horizontal .ant-col.ant-form-item-control-wrapper {
  height: 40px;
}

.ant-form-horizontal .ant-form-item-with-help {
  margin-bottom: 24px !important;
}

.ant-table-header,
.ant-table-body{
  width: calc(100% + 17px);
}

.ant-message-notice-content {
  font-size: 18px;
}

.ant-modal-confirm-content {
  font-size: 18px !important;
}

</style>
<script>
export default {
  created() {
  }
}
</script>
